import * as React from 'react'
import { Alert, Table } from 'reactstrap'

import { accentUtils, t, from, format, def} from './../../services/HelperService'
import { AccentSpinner } from '../AccentSpinner'
import { AccentTooltip } from '../AccentTooltip'
import { ToolbarToggleButton } from '../FilterButtons'
import * as DataService from '../../services/DataService'
import * as ProductService from '../../services/ProductService'
import { AiWandButton } from '../ai/AiWandButton'
import { ProductExplainerLauncher, buildJobLineExplainContext, canExplainProduct } from '../ai/productExplainerLauncher'
import { ProductExplainerDock } from '../ai/ProductExplainerChatPanel'
import { productExplainerEnabled } from '../workflow/queryShapingSessionProfiles'
import { isMobileOnly } from '../AccentDisplay'


const query_Job_PriceDetails = DataService.queryNoTracking("Job_PriceDetails");

var lineCostDiscountHack = {};

const JobPriceDetailsLineCtrl = props => {


    const padding = [];
    const level = accentUtils.isNull(props.level) ? 0 : props.level;


    const getPercentage = (n, d, sub1, emptyIfZero) => {
        if (accentUtils.isEmpty(d) || accentUtils.isEmpty(n)) {
            if (emptyIfZero) {
                return '';
            } else {
                return format.formatPercentage(0);
            }
        }

        const res = format.formatPercentage(accentUtils.roundNormal((n / d) - ((sub1) ? 1 : 0), 4));

        if ((res === "0%" || res === "-0%") && emptyIfZero) {
            return '';
        }

        return res;
    };

    const getMarkupPrecentage = (s, c) => {
        return getPercentage(s, c, true, false);
    };

    const getMarginPercentage = (s, c) => {
        return getPercentage(s - c, s, false, false);
    };

    const getMarkupAmount = (s, c) => {
        const r = s - c;

        return format.formatCurrency(r, false);

    };


    const discCost = props.cost + props.costAdhoc + props.discount;
    const disc = props.asPercentage ? getPercentage(-1.0 * props.discount, props.cost, false, true) : format.formatCurrency(props.discount * -1.0, true);
    const costBeforeAdhoc = props.cost + props.discount;


    const adhocCostDisc = props.asPercentage ? getPercentage(-1.0 * props.costAdhoc, costBeforeAdhoc, false, true) : format.formatCurrency(props.costAdhoc * -1.0, true);

    const salePriceBeforeAdhoc = props.retail + props.discountRetail;


    var salePrice = salePriceBeforeAdhoc + props.adhocDisc;

    if (Math.abs(accentUtils.round(salePrice, 2)) == 0) {
        salePrice = 0;
    }


    if (
        accentUtils.isEmpty(discCost) &&
        accentUtils.isEmpty(salePrice) &&
        accentUtils.isEmpty(props.cost) &&
        accentUtils.isEmpty(props.costAdhoc) &&
        accentUtils.isEmpty(props.discount)
    ) {
        return null;
    }

    const custDisc = props.asPercentage ? getPercentage(-1.0 * props.discountRetail, props.retail, false, true) : format.formatCurrency(props.discountRetail * -1.0, true);

    const adhocDisc = props.asPercentage ? getPercentage(-1.0 * props.adhocDisc, salePriceBeforeAdhoc, false, true) : format.formatCurrency(props.adhocDisc * -1.0, true);

    const margin = props.asPercentage ? getMarginPercentage(salePrice, discCost) : getMarkupAmount(salePrice, discCost);
    const markup = props.asPercentage ? getMarkupPrecentage(salePrice, discCost) : getMarkupAmount(salePrice, discCost);

    const toggle = level == 0 || level == 3 ? null : <span>{props.expanded ? "-" : "+"}</span>;

    const costLimit = (props.costLimited) ? "L" : null;
    const retailLimit = (props.retailLimited) ? "L" : null;

    const myOption = props.isMyOption ? <span><i>(not for supplier)</i></span> : null;
    const hasToolTip = !accentUtils.isEmpty(props.toolTip);

    // AI explainer focus state: while a line is being chatted about, its rows (the line
    // plus its BASE/option/breakdown children, matched by ownerLineID) highlight and
    // every other row fades — opacity only, so the whole table stays interactive.
    const isChatActive = !accentUtils.isEmpty(props.activeLineID);
    const isChatLine = isChatActive && props.ownerLineID === props.activeLineID;
    const focusClass = !isChatActive ? '' : (isChatLine ? ' acc-price-dtl-active' : ' acc-price-dtl-dim');

    // AI explainer entry point: only line-level rows receive onAskAssistant (never the
    // TOTAL, BASE, option or breakdown rows). The wand sits in its own white cell past
    // the MARGIN column so it stands out from the colored rows; it toggles the docked
    // chat for its line. stopPropagation keeps the click from expanding the row.
    const wand = accentUtils.isNull(props.onAskAssistant) ? null : <AiWandButton
        tagName={`askAssistant_${props.id}`}
        size={14}
        title={isChatLine
            ? t("Close the AI assistant for this line")
            : t("Ask the AI assistant about this line \u2014 e.g. why an option is hidden or how a price was calculated. Close and reopen to continue the same conversation.")}
        onClick={e => { e.stopPropagation(); props.onAskAssistant(); }}
    />;

    return <tr className={`acc-price-dtl-row-${level}${focusClass}`} onClick={() => {
        if (level != 0 && level != 3 && props.onClick) props.onClick(props);
    }}>
        <td style={{ textAlign: "left" }}>{toggle}<span id={props.id} className={`title-lvl-${level}`}>{props.title}{myOption}</span>{hasToolTip && <AccentTooltip target={props.id} html={props.toolTip} />} </td>
        <td>{format.formatCurrency(props.cost, true)}{costLimit}</td>
        <td>{disc}</td>
        <td>{adhocCostDisc}</td>
        <td>{format.formatCurrency(discCost, true)}</td>
        <td>{format.formatCurrency(props.retail, true)}{retailLimit}</td>
        <td>{custDisc}</td>
        <td>{adhocDisc}</td>
        <td>{format.formatCurrency(salePrice, false)}</td>
        <td>{markup}</td>
        <td>{margin}</td>
        {props.showWandColumn && <td className="acc-price-dtl-wand-cell">{wand}</td>}
    </tr >;
};


export class JobPriceDetailsErrorCtrl extends React.Component {

    static getDerivedStateFromError(error) {
        return { error: error };
    }

    constructor(props) {
        super(props);

        this.state = { error: null };

        this.componentDidCatch = this.componentDidCatch.bind(this);
    }

    componentDidCatch(error, errorInfo) {

    }


    render() {

        if (!accentUtils.isEmpty(this.state.error)) {
            return <Alert color="danger">
                An error occured while eveluating price details. Please contact support.
            </Alert>;
        }


        return <div>
            {this.props.children}
        </div>;

    }
}

export class JobPriceDetailsCtrl extends React.Component {

    constructor(props) {
        super(props);




        this.state = {
            jobData: props.lines,
            expanded: {},
            asPercentage: true,
            incTax: false,
            // The line whose docked AI explainer chat is open (null when closed): its
            // rows highlight, every other row dims (see JobPriceDetailsLineCtrl).
            activeLineID: null,
        };


        lineCostDiscountHack = {};

        // One explainer chat session per line row (keyed by line id), held for the
        // control's lifetime so close/reopen on the same line resumes the conversation.
        this.explainerLauncher = new ProductExplainerLauncher();

        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentWillUnmount = this.componentWillUnmount.bind(this);
        this.askAssistant = this.askAssistant.bind(this);
        this.buildExplainContext = this.buildExplainContext.bind(this);

        this.decorateDesc = this.decorateDesc.bind(this);
        this.decorateDescCombined = this.decorateDescCombined.bind(this);
        this.getQtyLookupToolTip = this.getQtyLookupToolTip.bind(this);
        this.appendToolTip = this.appendToolTip.bind(this);
        this.addToItem = this.addToItem.bind(this);
        this.getItem = this.getItem.bind(this);
        this.getCombinedItem = this.getCombinedItem.bind(this);
        this.onItemClicked = this.onItemClicked.bind(this);
        this.onDiscountTypeChange = this.onDiscountTypeChange.bind(this);
        this.onTaxTypeChange = this.onTaxTypeChange.bind(this);
        this.getOptionValueName = this.getOptionValueName.bind(this);

    }


    componentDidMount() {

        var me = this;

        if (accentUtils.isNull(this.state.jobData)) {
            query_Job_PriceDetails.getAll({ jobID: this.props.jobID }).then(r => {
                me.setState({ jobData: r });
            });
        }

    }

    componentWillUnmount() {
        this.explainerLauncher.dispose();
    }

    /**
     * The explainContextJson snapshot for one line row: the clicked line plus its
     * multi-config siblings (pricing of one member can depend on the group).
     */
    buildExplainContext(line) {

        const rows = (this.state.jobData ?? []).filter(l =>
            l.ID === line.ID || (!accentUtils.isEmpty(line.MultiGroupID) && l.MultiGroupID === line.MultiGroupID));

        return buildJobLineExplainContext(rows);
    }

    askAssistant(line) {

        // The docked panel needs horizontal room; on mobile the wand keeps opening the
        // modal assistant dialog instead.
        if (isMobileOnly) {
            this.explainerLauncher.open(line.ID, () => this.buildExplainContext(line));
            return;
        }

        const activeLineID = this.state.activeLineID === line.ID ? null : line.ID;

        // Auto-expand the newly focused line so its highlighted children make the chat
        // subject obvious against the dimmed rest of the table.
        const expanded = accentUtils.isNull(activeLineID)
            ? this.state.expanded
            : { ...this.state.expanded, [`line_${line.ID}`]: true };

        this.setState({ activeLineID, expanded });
    }



    onDiscountTypeChange(e) {

        this.setState({ asPercentage: e.value === 1 });

    }

    onTaxTypeChange(e) {
        this.setState({ incTax: e.value === 1 });
    }

    addToItem(dest, source) {

        if (source != null) {
            dest.costAdhoc += accentUtils.roundNormal(source.costAdhoc, 2);
            dest.adhocDisc += accentUtils.roundNormal(source.adhocDisc, 2);
            dest.cost += accentUtils.roundNormal(source.cost, 2);
            dest.discount += accentUtils.roundNormal(source.discount, 2);
            dest.discountRetail += accentUtils.roundNormal(source.discountRetail, 2);
            dest.retail += accentUtils.roundNormal(source.retail, 2);
        }
    }

    decorateDesc(desc, isDim, isQty, isPerc) {
        const parts = [];

        if (isDim) parts.push(isPerc ? "D%" : "D");
        if (isQty) parts.push(isPerc ? "Q%" : "Q");
        if (!isDim && !isQty && isPerc) parts.push("%");

        return parts.length > 0 ? `${desc} (${parts.join("|")})` : desc;
    }

    decorateDescCombined(desc, hasStandard, hasDim, hasQty, standardIsPerc, dimIsPerc, qtyIsPerc) {
        const parts = [];

        if (hasStandard) parts.push(standardIsPerc ? "S%" : "S");
        if (hasDim) parts.push(dimIsPerc ? "D%" : "D");
        if (hasQty) parts.push(qtyIsPerc ? "Q%" : "Q");

        return parts.length > 0 ? `${desc} (${parts.join("|")})` : desc;
    }

    getQtyLookupToolTip(qtyLookupInfos) {
        const entries = (qtyLookupInfos || []).filter(e => !accentUtils.isNull(e) && !accentUtils.isNull(e.info));

        if (entries.length === 0) {
            return null;
        }

        const fmt = v => accentUtils.isNull(v) ? "" : Number(v).toFixed(2);

        return entries.map(e => {
            const info = e.info;
            const selectedBreaks = info.SelectedBreakQuantities || [];
            const selectedBreakText = selectedBreaks.length > 0
                ? `<br>${info.Progressive ? "Selected qty breaks" : "Selected qty break"}: ${selectedBreaks.map(fmt).join(", ")}`
                : "";
            const label = accentUtils.isEmpty(e.label) ? "" : `${e.label}: `;

            return `<b>${label}Quantity pricing</b><br>Lookup quantity: ${fmt(info.LookupQuantity)}<br>Current line quantity: ${fmt(info.CurrentLineQuantity)}<br>Other matching lines: ${fmt(info.OtherLinesQuantity)}<br>Source: ${info.LookupSource || "Line Qty"}${selectedBreakText}`;
        }).join("<br><br>");
    }

    appendToolTip(toolTip, additionalToolTip) {
        if (accentUtils.isEmpty(additionalToolTip)) return accentUtils.isNull(toolTip) ? "" : toolTip;
        if (accentUtils.isEmpty(toolTip)) return additionalToolTip;

        return `${toolTip}<br><br>${additionalToolTip}`;
    }

    getItem(id, level, title, cost, disc, costAdhoc, retail, discRetail, adhocDisc, toolTip, salesTaxRate, costTaxRate, nullIfNoVal, costLimited, retailLimited) {

        salesTaxRate = accentUtils.isNull(salesTaxRate) ? 0 : salesTaxRate;
        costTaxRate = accentUtils.isNull(costTaxRate) ? 0 : costTaxRate;

        const saleTaxFactor = this.state.incTax ? ((100.00 + salesTaxRate) / 100.00) : 1;
        const costTaxFactor = this.state.incTax ? ((100.00 + costTaxRate) / 100.00) : 1;

        const toNum = v => {

            if (v) {
                return Number(v);
            }

            return 0;
        };


        const hasValue = (Math.abs(toNum(cost)) + Math.abs(toNum(disc)) + Math.abs(toNum(costAdhoc)) + Math.abs(toNum(retail)) + Math.abs(toNum(discRetail)) + Math.abs(toNum(adhocDisc))) > 0;        

        if (!hasValue && nullIfNoVal) return null;

        return {
            id: id,
            level: level,
            title: title,
            cost: cost * costTaxFactor,
            discount: disc * costTaxFactor,
            costAdhoc: costAdhoc,
            discountRetail: discRetail * saleTaxFactor,
            retail: retail * saleTaxFactor,
            adhocDisc: adhocDisc,// * saleTaxFactor,
            onClick: this.onItemClicked,
            asPercentage: this.state.asPercentage,
            toolTip: accentUtils.isNull(toolTip) ? '' : toolTip,
            salesTaxRate: salesTaxRate,
            costTaxRate: costTaxRate,
            costLimited: costLimited,
            retailLimited: retailLimited
        };

    }

    getCombinedItem(id, level, desc, 
        // Standard values
        stdCost, stdDisc, stdCostAdhoc, stdRetail, stdDiscRetail, stdAdhocDisc, stdCostIsPerc, stdCostLimited, stdRetailLimited,
        // Dimension values
        dimCost, dimDisc, dimCostAdhoc, dimRetail, dimDiscRetail, dimAdhocDisc, dimCostIsPerc, dimCostLimited, dimRetailLimited,
        // Quantity values
        qtyCost, qtyDisc, qtyCostAdhoc, qtyRetail, qtyDiscRetail, qtyAdhocDisc, qtyCostIsPerc, qtyCostLimited, qtyRetailLimited,
        // Common values
        toolTip, salesTaxRate, costTaxRate, nullIfNoVal, qtyLookupInfos) {

        salesTaxRate = accentUtils.isNull(salesTaxRate) ? 0 : salesTaxRate;
        costTaxRate = accentUtils.isNull(costTaxRate) ? 0 : costTaxRate;

        const saleTaxFactor = this.state.incTax ? ((100.00 + salesTaxRate) / 100.00) : 1;
        const costTaxFactor = this.state.incTax ? ((100.00 + costTaxRate) / 100.00) : 1;

        const toNum = v => {
            if (v) {
                return Number(v);
            }
            return 0;
        };

        // Convert to numbers, defaulting to 0
        const stdCostNum = toNum(stdCost);
        const stdDiscNum = toNum(stdDisc);
        const stdCostAdhocNum = toNum(stdCostAdhoc);
        const stdRetailNum = toNum(stdRetail);
        const stdDiscRetailNum = toNum(stdDiscRetail);
        const stdAdhocDiscNum = toNum(stdAdhocDisc);

        const dimCostNum = toNum(dimCost);
        const dimDiscNum = toNum(dimDisc);
        const dimCostAdhocNum = toNum(dimCostAdhoc);
        const dimRetailNum = toNum(dimRetail);
        const dimDiscRetailNum = toNum(dimDiscRetail);
        const dimAdhocDiscNum = toNum(dimAdhocDisc);

        const qtyCostNum = toNum(qtyCost);
        const qtyDiscNum = toNum(qtyDisc);
        const qtyCostAdhocNum = toNum(qtyCostAdhoc);
        const qtyRetailNum = toNum(qtyRetail);
        const qtyDiscRetailNum = toNum(qtyDiscRetail);
        const qtyAdhocDiscNum = toNum(qtyAdhocDisc);

        // Check if values exist
        const hasStandard = Math.abs(stdCostNum) + Math.abs(stdDiscNum) + Math.abs(stdCostAdhocNum) + 
                           Math.abs(stdRetailNum) + Math.abs(stdDiscRetailNum) + Math.abs(stdAdhocDiscNum) > 0;
        const hasDim = Math.abs(dimCostNum) + Math.abs(dimDiscNum) + Math.abs(dimCostAdhocNum) + 
                      Math.abs(dimRetailNum) + Math.abs(dimDiscRetailNum) + Math.abs(dimAdhocDiscNum) > 0;
        const hasQty = Math.abs(qtyCostNum) + Math.abs(qtyDiscNum) + Math.abs(qtyCostAdhocNum) +
                      Math.abs(qtyRetailNum) + Math.abs(qtyDiscRetailNum) + Math.abs(qtyAdhocDiscNum) > 0;

        // Return null if both are null/zero
        if (!hasStandard && !hasDim && !hasQty && nullIfNoVal) {
            return null;
        }

        // Sum raw values, then round to 2 decimals
        const combinedCost = accentUtils.roundNormal(stdCostNum + dimCostNum + qtyCostNum, 2);
        const combinedDisc = accentUtils.roundNormal(stdDiscNum + dimDiscNum + qtyDiscNum, 2);
        const combinedCostAdhoc = accentUtils.roundNormal(stdCostAdhocNum + dimCostAdhocNum + qtyCostAdhocNum, 2);
        const combinedRetail = accentUtils.roundNormal(stdRetailNum + dimRetailNum + qtyRetailNum, 2);
        const combinedDiscRetail = accentUtils.roundNormal(stdDiscRetailNum + dimDiscRetailNum + qtyDiscRetailNum, 2);
        const combinedAdhocDisc = accentUtils.roundNormal(stdAdhocDiscNum + dimAdhocDiscNum + qtyAdhocDiscNum, 2);

        // Apply tax factors after rounding
        const title = this.decorateDescCombined(desc, hasStandard, hasDim, hasQty, stdCostIsPerc, dimCostIsPerc, qtyCostIsPerc);
        const finalToolTip = this.appendToolTip(toolTip, this.getQtyLookupToolTip(qtyLookupInfos));
        
        // Limited flags: show "L" if either is limited
        const costLimited = (stdCostLimited || dimCostLimited || qtyCostLimited) || null;
        const retailLimited = (stdRetailLimited || dimRetailLimited || qtyRetailLimited) || null;

        return {
            id: id,
            level: level,
            title: title,
            cost: combinedCost * costTaxFactor,
            discount: combinedDisc * costTaxFactor,
            costAdhoc: combinedCostAdhoc,
            discountRetail: combinedDiscRetail * saleTaxFactor,
            retail: combinedRetail * saleTaxFactor,
            adhocDisc: combinedAdhocDisc,// * saleTaxFactor,
            onClick: this.onItemClicked,
            asPercentage: this.state.asPercentage,
            toolTip: finalToolTip,
            salesTaxRate: salesTaxRate,
            costTaxRate: costTaxRate,
            costLimited: costLimited,
            retailLimited: retailLimited
        };
    }

    onItemClicked(item) {

        var expanded = this.state.expanded[item.id];

        var newState = { ...this.state.expanded };

        newState[item.id] = !expanded;

        this.setState({ expanded: newState });


    }

    getOptionValueName(olos, priceModel, valueID) {

        if (accentUtils.isEmpty(valueID)) {
            return '';
        }

        return from(olos).where(i => i.ProductOptionValueID.toUpperCase() == valueID.toUpperCase())
            .select(i => i.ProductOptionValueName
            ).firstOrDefault();
    }

    render() {

        var me = this;




        if (accentUtils.isNull(this.state.jobData)) {
            return <AccentSpinner />;
        }

        const jobItem = me.getItem(-1, 0, "TOTAL", 0, 0, 0, 0, 0, 0, false);

        // AI explainer wand on the line rows: gated by the FeatureAllowProductExplainer
        // user feature (see productExplainerEnabled) so every host gates identically.
        const canAskAssistant = productExplainerEnabled();

        const rows = [];

        this.state.jobData.map(l => {

            // Align line totals with job-line totals by allocating any rounding remainder
            // to the largest component (Amount/Install/Delivery), mirroring discount-screen behavior.
            const addRetailDelta = (obj, delta) => {
                if (accentUtils.isNull(obj) || accentUtils.isNull(delta) || delta === 0) return;
                obj.retail = accentUtils.roundNormal(def(obj.retail, 0) + delta, 2);
            };

            const getLineSalePrice = (lineObj) => {
                const salePrice = def(lineObj.retail, 0) + def(lineObj.discountRetail, 0) + def(lineObj.adhocDisc, 0);
                return accentUtils.roundNormal(salePrice, 2);
            };

            const reconcileCandidates = [];

            const pushCandidate = (bucket, sizeEx, preferBase, id, adjustChain) => {
                const chain = (adjustChain || []).filter(x => !accentUtils.isNull(x));
                if (chain.length === 0) return;

                reconcileCandidates.push({
                    bucket,
                    sizeEx: Math.abs(Number(sizeEx) || 0),
                    preferBase: preferBase ? 0 : 1,
                    id: id || "",
                    adjustChain: chain
                });
            };

            const chooseLargestBucket = (bucketTotals) => {
                const a = def(bucketTotals.AMOUNT, 0);
                const i = def(bucketTotals.INSTALL, 0);
                const d = def(bucketTotals.DELIVERY, 0);

                // Deterministic tie-break: AMOUNT > INSTALL > DELIVERY
                if (a >= i && a >= d) return "AMOUNT";
                if (i >= d) return "INSTALL";
                return "DELIVERY";
            };

            const reconcileLineSale = (lineItem, targetSalePrice) => {
                const computed = getLineSalePrice(lineItem);
                const delta = accentUtils.roundNormal(def(targetSalePrice, 0) - computed, 2);

                if (delta === 0) return;
                if (Math.abs(delta) > 0.05) return;

                const totals = { AMOUNT: 0, INSTALL: 0, DELIVERY: 0 };
                for (let i = 0; i < reconcileCandidates.length; i++) {
                    const c = reconcileCandidates[i];
                    totals[c.bucket] = def(totals[c.bucket], 0) + def(c.sizeEx, 0);
                }

                const chosenBucket = chooseLargestBucket(totals);

                const chosen = from(reconcileCandidates)
                    .where(c => c.bucket === chosenBucket)
                    .orderByDescending(c => c.sizeEx)
                    .thenBy(c => c.preferBase)
                    .thenBy(c => c.id)
                    .firstOrDefault();

                if (accentUtils.isNull(chosen)) {
                    addRetailDelta(lineItem, delta);
                    return;
                }

                for (let i = 0; i < chosen.adjustChain.length; i++) {
                    addRetailDelta(chosen.adjustChain[i], delta);
                }
            };

            const priceModel = JSON.parse(l.PriceModel);
            const olos = from(JSON.parse(l.OrderLineOptionsData))
                .groupBy(o => o.ProductOptionID.toUpperCase())
                .select(o => {

                    var result = o.getSource()[0];

                    if (result.IsExtra) {

                        var items = o.getSource();


                        if (items.length > 1) {

                            var customValue = from(items).select(i => window.InsyteProduct.InsyteWeb.InsyteWebDiscountHelper.GetExtraInfo(i.CustomValue, i.AdditionalValue))
                                .groupBy(i => i.UnitTypeDescription).
                                select(g => `${from(g.getSource()).sum(v => Number(v.Qty)).toFixed(2)} ${g.key()}`)
                                .toArray()
                                .join();


                            return { ...result, CustomValue: customValue };

                        }

                        return result;

                    }

                    return result;

                }).toArray();


            const productName = l.ProductName;


            lineCostDiscountHack[l.ID] = me.state.incTax ? l.CostPriceIncTax : l.CostPrice;

            const tt = accentUtils.isNull(priceModel) ? "No pricing details available" :
                `Price List : ${priceModel.PriceListName} v${accentUtils.isEmpty(priceModel.PriceListVersion) ? "0" : priceModel.PriceListVersion}<br>Pricing 1: ${priceModel.UseGroupCodeOption1 ? priceModel.PricingOption1GroupCode : me.getOptionValueName(olos, priceModel, priceModel.PricingOption1ValueID)}<br>Pricing 2: ${priceModel.UseGroupCodeOption2 ? priceModel.PricingOption2GroupCode : me.getOptionValueName(olos, priceModel, priceModel.PricingOption2ValueID)}<br>Sales Tax Rate: ${l.SalesTaxRate}%<br>Cost Tax Rate: ${l.CostTaxRate}%`;

            const lineItem = accentUtils.isNull(priceModel)
                ? me.getItem(
                    `line_${l.ID}`,
                    1,
                    `${l.JobLineNo} ${l.LocationOther}: ${productName} x ${l.Qty} (${l.Width} x ${l.Drop})`,
                    l.OriginalCostPrice,
                    0,
                    (me.state.incTax ? l.CostPriceIncTax - l.OriginalCostPriceIncTax : l.CostPrice - l.OriginalCostPrice),
                    l.Price,
                    0, (me.state.incTax ? l.SalePriceIncTax - l.PriceIncTax : l.SalePrice - l.Price),
                    tt,
                    l.SalesTaxRate,
                    l.CostTaxRate,
                    false)
                : me.getItem(
                    `line_${l.ID}`,
                    1,
                    `${l.JobLineNo} ${l.LocationOther}: ${productName} - v${accentUtils.isEmpty(l.ProductVersion) ? "0" : l.ProductVersion} x ${l.Qty} (${l.Width} x ${l.Drop})`,
                    0,
                    0,
                    0,
                    0,
                    0,
                    (me.state.incTax ? l.SalePriceIncTax - l.PriceIncTax : l.SalePrice - l.Price), tt, l.SalesTaxRate, l.CostTaxRate, false);

            if (accentUtils.isNull(priceModel)) {
                rows.push(<JobPriceDetailsLineCtrl key={l.ID} {...lineItem} ownerLineID={l.ID} expanded={false} onAskAssistant={canAskAssistant && canExplainProduct(l.ProductID) ? () => me.askAssistant(l) : null} />);
                me.addToItem(jobItem, lineItem);
                return;
            }


            const basePriceItem = from(priceModel.CostItems).where(i => i.ItemID.toUpperCase() == l.ProductID.toUpperCase() && i.HasValue).firstOrDefault();

            const baseItem = me.getItem(`line_base_${l.ID}`, 2, "BASE", 0, 0, 0, 0, 0, 0, null, l.SalesTaxRate, l.CostTaxRate, false);

            var baseAmountItem = null;
            var baseDeliveryItem = null;
            var baseInstallItem = null;

            if (!accentUtils.isNull(basePriceItem)) {

                baseAmountItem = me.getCombinedItem(
                    `line_base_amount_${l.ID}`, 
                    3, 
                    "AMOUNT",
                    // Standard values
                    basePriceItem.Cost, basePriceItem.StandardCostDiscount, null, 
                    basePriceItem.RetailPrice, basePriceItem.StandardRetailDiscount, 0,
                    basePriceItem.CostIsPerc, basePriceItem.CostLimited, basePriceItem.RetailPriceLimited,
                    // Dimension values
                    basePriceItem.DimCost, basePriceItem.StandardDimCostDiscount, null,
                    basePriceItem.DimRetailPrice, basePriceItem.StandardDimRetailDiscount, 0,
                    basePriceItem.DimCostIsPerc, basePriceItem.DimCostLimited, basePriceItem.DimRetailPriceLimited,
                    // Quantity values
                    basePriceItem.QtyCost, basePriceItem.StandardQtyCostDiscount, null,
                    basePriceItem.QtyRetailPrice, basePriceItem.StandardQtyRetailDiscount, 0,
                    basePriceItem.QtyCostIsPerc, basePriceItem.QtyCostLimited, basePriceItem.QtyRetailPriceLimited,
                    // Common values
                    null, l.SalesTaxRate, l.CostTaxRate, true,
                    [{ label: "Cost", info: basePriceItem.QtyCostLookupInfo }, { label: "Retail", info: basePriceItem.QtyRetailPriceLookupInfo }]
                );

                pushCandidate(
                    "AMOUNT",
                    def(basePriceItem.RetailPrice, 0) + def(basePriceItem.DimRetailPrice, 0) + def(basePriceItem.QtyRetailPrice, 0),
                    true,
                    baseAmountItem?.id,
                    [baseAmountItem, baseItem, lineItem]
                );

                baseDeliveryItem = me.getCombinedItem(
                    `line_base_delivery_${l.ID}`, 
                    3, 
                    "DELIVERY",
                    // Standard values
                    basePriceItem.CostDelivery, basePriceItem.StandardCostDeliveryDiscount, null,
                    basePriceItem.DeliveryPrice, basePriceItem.StandardRetailDeliveryDiscount, 0,
                    basePriceItem.CostDeliveryIsPerc, basePriceItem.CostDeliveryLimited, basePriceItem.DelivieryPriceLimited,
                    // Dimension values
                    basePriceItem.DimCostDelivery, basePriceItem.StandardDimCostDeliveryDiscount, null,
                    basePriceItem.DimDeliveryPrice, basePriceItem.StandardDimRetailDeliveryDiscount, 0,
                    basePriceItem.DimCostDeliveryIsPerc, basePriceItem.DimCostDeliveryLimited, basePriceItem.DimDelivieryPriceLimited,
                    // Quantity values
                    basePriceItem.QtyCostDelivery, basePriceItem.StandardQtyCostDeliveryDiscount, null,
                    basePriceItem.QtyDeliveryPrice, basePriceItem.StandardQtyRetailDeliveryDiscount, 0,
                    basePriceItem.QtyCostDeliveryIsPerc, basePriceItem.QtyCostDeliveryLimited, basePriceItem.QtyDeliveryPriceLimited,
                    // Common values
                    null, l.SalesTaxRate, l.CostTaxRate, true,
                    [{ label: "Cost", info: basePriceItem.QtyCostDeliveryLookupInfo }, { label: "Delivery", info: basePriceItem.QtyDeliveryPriceLookupInfo }]
                );

                pushCandidate(
                    "DELIVERY",
                    def(basePriceItem.DeliveryPrice, 0) + def(basePriceItem.DimDeliveryPrice, 0) + def(basePriceItem.QtyDeliveryPrice, 0),
                    true,
                    baseDeliveryItem?.id,
                    [baseDeliveryItem, baseItem, lineItem]
                );

                baseInstallItem = me.getCombinedItem(
                    `line_base_install_${l.ID}`, 
                    3, 
                    "INSTALL",
                    // Standard values
                    basePriceItem.CostInstall, basePriceItem.StandardCostInstallDiscount, null,
                    basePriceItem.InstallPrice, basePriceItem.StandardRetailInstallDiscount, 0,
                    basePriceItem.CostInstallIsPerc, basePriceItem.CostInstallLimited, basePriceItem.InstallPriceLimited,
                    // Dimension values
                    basePriceItem.DimCostInstall, basePriceItem.StandardDimCostInstallDiscount, null,
                    basePriceItem.DimInstallPrice, basePriceItem.StandardDimRetailInstallDiscount, 0,
                    basePriceItem.DimCostInstallIsPerc, basePriceItem.DimCostInstallLimited, basePriceItem.DimInstallPriceLimited,
                    // Quantity values
                    basePriceItem.QtyCostInstall, basePriceItem.StandardQtyCostInstallDiscount, null,
                    basePriceItem.QtyInstallPrice, basePriceItem.StandardQtyRetailInstallDiscount, 0,
                    basePriceItem.QtyCostInstallIsPerc, basePriceItem.QtyCostInstallLimited, basePriceItem.QtyInstallPriceLimited,
                    // Common values
                    null, l.SalesTaxRate, l.CostTaxRate, true,
                    [{ label: "Cost", info: basePriceItem.QtyCostInstallLookupInfo }, { label: "Install", info: basePriceItem.QtyInstallPriceLookupInfo }]
                );

                pushCandidate(
                    "INSTALL",
                    def(basePriceItem.InstallPrice, 0) + def(basePriceItem.DimInstallPrice, 0) + def(basePriceItem.QtyInstallPrice, 0),
                    true,
                    baseInstallItem?.id,
                    [baseInstallItem, baseItem, lineItem]
                );

                // Only add combined items to parent
                me.addToItem(baseItem, baseAmountItem);
                me.addToItem(baseItem, baseDeliveryItem);
                me.addToItem(baseItem, baseInstallItem);

            }
            me.addToItem(lineItem, baseItem);

            const optionRows = [];

            from(olos).orderBy(o => o.ProductOptionGroupSort)
                .thenBy(o => o.ProductOptionSort)
                .thenBy(o => o.ProductOptionValueSort)
                .select(o => {
                    const costItems = from(priceModel.CostItems)
                        .where(c=>c.HasValue)
                        .where(c => c.ItemID.toUpperCase() == o.ProductOptionValueID.toUpperCase() || c.ItemID.toUpperCase() == o.ProductOptionID.toUpperCase() || c.ItemID.toUpperCase() == o.ProductOptionGroupID.toUpperCase()).orderBy(c => c.Type).toArray();


                    if (accentUtils.isNull(costItems) || costItems.length == 0) {
                        return null;
                    }


                    for (var i = 0; i < costItems.length; i++) {

                        const c = costItems[i];


                        const desc = (c.Type == 2 && !o.IsExtra) ? o.ProductOptionName : `${o.ProductOptionName} - ${o.CustomValue}`;

                        const optionItem = me.getItem(`line_option_${l.ID}_${c.ItemID}_${c.Type}`, 2, desc, 0, 0, 0, 0, 0, 0);

                        var optionAmountItem = null;
                        var optionDeliveryItem = null;
                        var optionInstallItem = null;

                        // Create combined items for Type 3 (standard + dimension + quantity)
                        if (c.Type == 3) {
                            optionAmountItem = me.getCombinedItem(
                                `line_option_amount_${l.ID}_${c.ItemID}_${c.Type}`, 
                                3, 
                                "AMOUNT",
                                // Standard values
                                c.Cost, c.StandardCostDiscount, null,
                                c.RetailPrice, c.StandardRetailDiscount, 0,
                                c.CostIsPerc, c.CostLimited, c.RetailPriceLimited,
                                // Dimension values
                                c.DimCost, c.StandardDimCostDiscount, null,
                                c.DimRetailPrice, c.StandardDimRetailDiscount, 0,
                                c.DimCostIsPerc, c.DimCostLimited, c.DimRetailPriceLimited,
                                // Quantity values
                                c.QtyCost, c.StandardQtyCostDiscount, null,
                                c.QtyRetailPrice, c.StandardQtyRetailDiscount, 0,
                                c.QtyCostIsPerc, c.QtyCostLimited, c.QtyRetailPriceLimited,
                                // Common values
                                null, l.SalesTaxRate, l.CostTaxRate, true,
                                [{ label: "Cost", info: c.QtyCostLookupInfo }, { label: "Retail", info: c.QtyRetailPriceLookupInfo }]
                            );

                            optionDeliveryItem = me.getCombinedItem(
                                `line_option_delivery_${l.ID}_${c.ItemID}_${c.Type}`, 
                                3, 
                                "DELIVERY",
                                // Standard values
                                c.CostDelivery, c.StandardCostDeliveryDiscount, null,
                                c.DeliveryPrice, c.StandardRetailDeliveryDiscount, 0,
                                c.CostDeliveryIsPerc, c.CostDeliveryLimited, c.DelivieryPriceLimited,
                                // Dimension values
                                c.DimCostDelivery, c.StandardDimCostDeliveryDiscount, null,
                                c.DimDeliveryPrice, c.StandardDimRetailDeliveryDiscount, 0,
                                c.DimCostDeliveryIsPerc, c.DimCostDeliveryLimited, c.DimDelivieryPriceLimited,
                                // Quantity values
                                c.QtyCostDelivery, c.StandardQtyCostDeliveryDiscount, null,
                                c.QtyDeliveryPrice, c.StandardQtyRetailDeliveryDiscount, 0,
                                c.QtyCostDeliveryIsPerc, c.QtyCostDeliveryLimited, c.QtyDeliveryPriceLimited,
                                // Common values
                                null, l.SalesTaxRate, l.CostTaxRate, true,
                                [{ label: "Cost", info: c.QtyCostDeliveryLookupInfo }, { label: "Delivery", info: c.QtyDeliveryPriceLookupInfo }]
                            );

                            optionInstallItem = me.getCombinedItem(
                                `line_option_install_${l.ID}_${c.ItemID}_${c.Type}`, 
                                3, 
                                "INSTALL",
                                // Standard values
                                c.CostInstall, c.StandardCostInstallDiscount, null,
                                c.InstallPrice, c.StandardRetailInstallDiscount, 0,
                                c.CostInstallIsPerc, c.CostInstallLimited, c.InstallPriceLimited,
                                // Dimension values
                                c.DimCostInstall, c.StandardDimCostInstallDiscount, null,
                                c.DimInstallPrice, c.StandardDimRetailInstallDiscount, 0,
                                c.DimCostInstallIsPerc, c.DimCostInstallLimited, c.DimInstallPriceLimited,
                                // Quantity values
                                c.QtyCostInstall, c.StandardQtyCostInstallDiscount, null,
                                c.QtyInstallPrice, c.StandardQtyRetailInstallDiscount, 0,
                                c.QtyCostInstallIsPerc, c.QtyCostInstallLimited, c.QtyInstallPriceLimited,
                                // Common values
                                null, l.SalesTaxRate, l.CostTaxRate, true,
                                [{ label: "Cost", info: c.QtyCostInstallLookupInfo }, { label: "Install", info: c.QtyInstallPriceLookupInfo }]
                            );
                        } else {
                            // For Type 1 (option group) and Type 2 (option), dimension values aren't supported
                            // but standard + quantity pricing can both exist. Route through getCombinedItem so
                            // the (S|Q) indicator can be emitted by decorateDescCombined when both apply.
                            optionAmountItem = me.getCombinedItem(
                                `line_option_amount_${l.ID}_${c.ItemID}_${c.Type}`,
                                3,
                                "AMOUNT",
                                // Standard values
                                c.Cost, c.StandardCostDiscount, null,
                                c.RetailPrice, c.StandardRetailDiscount, 0,
                                c.CostIsPerc, c.CostLimited, c.RetailPriceLimited,
                                // Dimension values (not supported at option/group level)
                                0, 0, null,
                                0, 0, 0,
                                false, false, false,
                                // Quantity values
                                c.QtyCost, c.StandardQtyCostDiscount, null,
                                c.QtyRetailPrice, c.StandardQtyRetailDiscount, 0,
                                c.QtyCostIsPerc, c.QtyCostLimited, c.QtyRetailPriceLimited,
                                // Common values
                                null, l.SalesTaxRate, l.CostTaxRate, true,
                                [{ label: "Cost", info: c.QtyCostLookupInfo }, { label: "Retail", info: c.QtyRetailPriceLookupInfo }]
                            );

                            optionDeliveryItem = me.getCombinedItem(
                                `line_option_delivery_${l.ID}_${c.ItemID}_${c.Type}`,
                                3,
                                "DELIVERY",
                                // Standard values
                                c.CostDelivery, c.StandardCostDeliveryDiscount, null,
                                c.DeliveryPrice, c.StandardRetailDeliveryDiscount, 0,
                                c.CostDeliveryIsPerc, c.CostDeliveryLimited, c.DelivieryPriceLimited,
                                // Dimension values (not supported at option/group level)
                                0, 0, null,
                                0, 0, 0,
                                false, false, false,
                                // Quantity values
                                c.QtyCostDelivery, c.StandardQtyCostDeliveryDiscount, null,
                                c.QtyDeliveryPrice, c.StandardQtyRetailDeliveryDiscount, 0,
                                c.QtyCostDeliveryIsPerc, c.QtyCostDeliveryLimited, c.QtyDeliveryPriceLimited,
                                // Common values
                                null, l.SalesTaxRate, l.CostTaxRate, true,
                                [{ label: "Cost", info: c.QtyCostDeliveryLookupInfo }, { label: "Delivery", info: c.QtyDeliveryPriceLookupInfo }]
                            );

                            optionInstallItem = me.getCombinedItem(
                                `line_option_install_${l.ID}_${c.ItemID}_${c.Type}`,
                                3,
                                "INSTALL",
                                // Standard values
                                c.CostInstall, c.StandardCostInstallDiscount, null,
                                c.InstallPrice, c.StandardRetailInstallDiscount, 0,
                                c.CostInstallIsPerc, c.CostInstallLimited, c.InstallPriceLimited,
                                // Dimension values (not supported at option/group level)
                                0, 0, null,
                                0, 0, 0,
                                false, false, false,
                                // Quantity values
                                c.QtyCostInstall, c.StandardQtyCostInstallDiscount, null,
                                c.QtyInstallPrice, c.StandardQtyRetailInstallDiscount, 0,
                                c.QtyCostInstallIsPerc, c.QtyCostInstallLimited, c.QtyInstallPriceLimited,
                                // Common values
                                null, l.SalesTaxRate, l.CostTaxRate, true,
                                [{ label: "Cost", info: c.QtyCostInstallLookupInfo }, { label: "Install", info: c.QtyInstallPriceLookupInfo }]
                            );
                        }

                        // Only add combined items to parent
                        me.addToItem(optionItem, optionAmountItem);
                        me.addToItem(optionItem, optionDeliveryItem);
                        me.addToItem(optionItem, optionInstallItem);


                        me.addToItem(lineItem, optionItem);

                        const isMyOption = c.IsMyOption;

                        optionRows.push({ optionItem, optionAmountItem, optionDeliveryItem, optionInstallItem, isMyOption });

                        pushCandidate(
                            "AMOUNT",
                            def(c.RetailPrice, 0) + def(c.DimRetailPrice, 0) + def(c.QtyRetailPrice, 0),
                            false,
                            optionAmountItem?.id,
                            [optionAmountItem, optionItem, lineItem]
                        );
                        pushCandidate(
                            "DELIVERY",
                            def(c.DeliveryPrice, 0) + def(c.DimDeliveryPrice, 0) + def(c.QtyDeliveryPrice, 0),
                            false,
                            optionDeliveryItem?.id,
                            [optionDeliveryItem, optionItem, lineItem]
                        );
                        pushCandidate(
                            "INSTALL",
                            def(c.InstallPrice, 0) + def(c.DimInstallPrice, 0) + def(c.QtyInstallPrice, 0),
                            false,
                            optionInstallItem?.id,
                            [optionInstallItem, optionItem, lineItem]
                        );
                    }
                    return null;

                }).toArray();


            lineItem.costAdhoc = (def(lineItem.cost, 0) + def(lineItem.discount, 0) - def(lineCostDiscountHack[l.ID], 0)) * -1;

            // Ensure the line sale price total matches the authoritative job-line value for the selected mode.
            reconcileLineSale(lineItem, me.state.incTax ? l.SalePriceIncTax : l.SalePrice);

            me.addToItem(jobItem, lineItem);

            rows.push(<JobPriceDetailsLineCtrl key={l.ID} {...lineItem} ownerLineID={l.ID} expanded={me.state.expanded[lineItem.id]} onAskAssistant={canAskAssistant && canExplainProduct(l.ProductID) ? () => me.askAssistant(l) : null} />);

            if (me.state.expanded[lineItem.id]) {

                rows.push(<JobPriceDetailsLineCtrl key={`base_${l.ID}`} {...baseItem} ownerLineID={l.ID} expanded={me.state.expanded[baseItem.id]} />);

                if (me.state.expanded[baseItem.id]) {

                    if (!accentUtils.isNull(baseAmountItem))
                        rows.push(<JobPriceDetailsLineCtrl key={`base_amount_${l.ID}`} {...baseAmountItem} ownerLineID={l.ID} />);
                    if (!accentUtils.isNull(baseDeliveryItem))
                        rows.push(<JobPriceDetailsLineCtrl key={`base_delivery_${l.ID}`} {...baseDeliveryItem} ownerLineID={l.ID} />);
                    if (!accentUtils.isNull(baseInstallItem))
                        rows.push(<JobPriceDetailsLineCtrl key={`base_install_${l.ID}`} {...baseInstallItem} ownerLineID={l.ID} />);

                }

                optionRows.forEach(or => {
                    rows.push(<JobPriceDetailsLineCtrl key={or.optionItem.id} {...or.optionItem} ownerLineID={l.ID} expanded={me.state.expanded[or.optionItem.id]} isMyOption={or.isMyOption} />);

                    if (me.state.expanded[or.optionItem.id]) {
                        if (or.optionAmountItem != null) rows.push(<JobPriceDetailsLineCtrl key={or.optionAmountItem.id} {...or.optionAmountItem} ownerLineID={l.ID} />);
                        if (or.optionDeliveryItem != null) rows.push(<JobPriceDetailsLineCtrl key={or.optionDeliveryItem.id} {...or.optionDeliveryItem} ownerLineID={l.ID} />);
                        if (or.optionInstallItem != null) rows.push(<JobPriceDetailsLineCtrl key={or.optionInstallItem.id} {...or.optionInstallItem} ownerLineID={l.ID} />);
                    }
                });

            }


        });


        rows.unshift(<JobPriceDetailsLineCtrl key={`job_${me.props.jobID}`} {...jobItem} />);

        var optionFilter = [
            { ID: 1, Text: t("application_strings.views.job.percentage"), tagName: 'Percentage' },
            { ID: 2, Text: t("application_strings.views.job.dollar"), tagName: 'Dollar' },
        ];

        var btns = <ToolbarToggleButton defaultValue={1} options={optionFilter} onChange={this.onDiscountTypeChange} />;


        var optionTax = [
            { ID: 1, Text: t("application_strings.views.job.incTax"), tagName: 'IncTax' },
            { ID: 2, Text: t("application_strings.views.job.exTax"), tagName: 'ExTax' },
        ];

        var btnsTax = <ToolbarToggleButton defaultValue={2} options={optionTax} onChange={this.onTaxTypeChange} />;

        // The wand column and the focus highlight/dim states apply to EVERY row (column
        // alignment), so they are decorated centrally instead of at each push site.
        const decoratedRows = rows.map(r => React.cloneElement(r, {
            showWandColumn: canAskAssistant,
            activeLineID: me.state.activeLineID,
        }));

        const table = <Table responsive>
            <thead>
                <tr style={{ textAlign: "right" }}>
                    <th>{btnsTax} {btns}</th>
                    <th>COST</th>
                    <th>COST DISC</th>
                    <th>COST ADHOC</th>
                    <th>DISC COST</th>
                    <th>RETAIL</th>
                    <th>DISC CUST</th>
                    <th>DISC ADHOC</th>
                    <th>SALE PRICE</th>
                    <th>MARKUP</th>
                    <th>MARGIN</th>
                    {canAskAssistant && <th className="acc-price-dtl-wand-cell"></th>}
                </tr>
            </thead>
            <tbody>
                {decoratedRows}
            </tbody>
        </Table>;

        const activeLine = accentUtils.isNull(me.state.activeLineID)
            ? null
            : from(this.state.jobData).where(x => x.ID === me.state.activeLineID).firstOrDefault();

        if (accentUtils.isNull(activeLine)) return table;

        // Docked explainer chat for the focused line. Keyed by the line so switching
        // wands remounts the panel onto that line's own session (the launcher holds one
        // conversation per line id; the panel seeds its transcript on mount only).
        return <ProductExplainerDock
            key={activeLine.ID}
            explainerChat={{
                buildContextJson: () => this.buildExplainContext(activeLine),
                getSession: () => this.explainerLauncher.getSession(activeLine.ID),
                setSession: (s) => this.explainerLauncher.setSession(activeLine.ID, s),
            }}
            onClose={() => this.setState({ activeLineID: null })}
        >
            {table}
        </ProductExplainerDock>;
    }
}

